import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListView } from '@/shared/components/custom/list-view/components/ListView';
import { getAssignedFormColumns } from '../../adapters/formColumns';
import type { FormSummary } from '../../types';

interface AssignedFormsTableProps {
  forms: FormSummary[];
}

export function AssignedFormsTable({ forms }: AssignedFormsTableProps) {
  const { t } = useTranslation('forms');
  const { orgId } = useParams<{ orgId: string }>();

  const columns = getAssignedFormColumns({ t, orgId: orgId ?? '' });

  return (
    <ListView
      data={forms}
      columns={columns}
      getRowId={(form) => form.id}
      data-testid="forms-assigned-table"
    />
  );
}
